module.exports = __webpack_public_path__ + "static/media/tidehunter.1d5069ee.png";